module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.to) ? _c('a', _vm._b({}, 'a', _vm.$props, false), [_c('router-link', {
    attrs: {
      "to": _vm.to
    }
  }, [_vm._t("default")], 2)], 1) : (!!_vm.href) ? _c('a', _vm._b({}, 'a', _vm.$props, false), [_vm._t("default")], 2) : _c('button', _vm._b({
    staticClass: "dawn-button",
    class: _vm.buttonClass,
    on: {
      "click": function($event) {
        _vm.$emit("click", $event)
      }
    }
  }, 'button', _vm.$props, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e2828b2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edButton/index.vue
// module id = oK+y
// module chunks = 13 14